<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-03-31 09:18:26
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-04-01 14:13:06
 * @Description: 协商价格
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/negotiatePricesDialog.vue
-->
<template>
  <el-dialog :visible.sync="negotiatePricesDialog" width="1500px" :close-on-click-modal="false" :before-close="close">
    <span slot="title" class="dialog-title">协商价格配置</span>
    <div class="dialoginfo">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 10px">
        <div>生效时间: {{ data.effectiveTime || "-" }}</div>
      </div>
      <div style="height: 700px; overflow-y: auto">
        <!-- 第一部分 - 强度等级 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%; margin-top: 20px" :data="mainDate.strengthGrade || []" tooltip-effect="dark">
          <el-table-column align="center" label="强度等级" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 200px"
                placeholder="请输入"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 第二部分 - 性能等级 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%; margin-top: 20px" :data="mainDate.performanceGrade || []" tooltip-effect="dark">
          <el-table-column align="center" label="性能等级" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 200px"
                placeholder="请输入"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 第三部分 - 特殊要求 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%; margin-top: 20px" :data="mainDate.specialRequirements || []" tooltip-effect="dark">
          <el-table-column align="center" label="特殊要求" prop="startTime" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 200px"
                placeholder="请输入"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 第三部分 - 外加剂要求 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%; margin-top: 20px" :data="mainDate.admixtureRequirements || []" tooltip-effect="dark">
          <el-table-column align="center" label="外加剂要求" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 200px"
                placeholder="请输入"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 第三部分 - 材料要求 -->
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%; margin-top: 20px" :data="mainDate.meterialRequirements || []" tooltip-effect="dark">
          <el-table-column align="center" label="材料要求" width="auto">
            <template slot-scope="scope">
              <span>{{ scope.row.askName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 200px"
                placeholder="请输入"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="不含税价格" width="auto">
            <template slot-scope="scope">
              <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 其他要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="mainDate.otherRequirements" tooltip-effect="dark">
          <el-table-column prop="askName" label="其他要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 200px"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
        <!-- 第四部分 - 组合 -->
        <div style="margin-top: 10px">
          <el-button v-if="!isLook" class="bottom_all_two" style="margin-right: 24px" @click="addProductComposePriceDig = true">添加其它组合</el-button>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%; margin-top: 20px" :data="productComposePriceList" tooltip-effect="dark">
            <el-table-column align="center" label="材料要求" prop="productName" width="auto"> </el-table-column>
            <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.priceIncludinTax"
                  :disabled="isLook"
                  type="Number"
                  style="width: 200px"
                  placeholder="请输入"
                  @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                  @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="不含税价格" prop="priceExcludingTax" width="auto">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" width="auto" align="center">
              <template slot-scope="scope">
                <el-link v-if="!isLook" type="danger" :underline="false" @click="deleteProductComposePrice(scope.$index)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 第五部分 - 特殊产品 -->
        <div style="margin-top: 10px">
          <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="tableData_other" tooltip-effect="dark">
            <el-table-column v-for="(item, index) in table_other" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center" :fixed="item.label == '操作' ? 'right' : false">
              <template slot-scope="scope">
                <span v-if="item.label == '费用标准'">
                  <el-select v-model="scope.row.costStandard" :disabled="isLook" placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in table_other_options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '含税价格'">
                  <el-input
                    v-model="scope.row.priceIncludinTax"
                    :disabled="isLook"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                    @blur="priceExcludingTaxFun(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
                  >
                  </el-input>
                </span>
                <span v-else-if="item.label == '不含税价格'">
                  <el-input
                    v-model="scope.row.priceExcludingTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceExcludingTax = $regExp.checkNum4(scope.row.priceExcludingTax)"
                    @blur="priceIncludinTaxFun(scope.row), (scope.row.priceExcludingTax = $regExp.blurCheckNum(scope.row.priceExcludingTax))" @mousewheel.native.prevent
                  >
                  </el-input>
                </span>
                <span v-else>{{ scope.row[item.prop] || "*" }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 第六部分 - 同比例砂浆-->
        <div>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; margin-top: 10px">
            <div>同比例砂浆：</div>
            <el-select v-model="mortar.strengthGradeId" disabled placeholder="请选择" style="width: 120px">
              <el-option v-for="item in [{ id: '0001', name: '相同强度' }, ...config_options.strengthGrade]" :key="item.id" :label="item.name" :value="item.id" @click.native="selectMortarFun(item)"> </el-option>
            </el-select>
            <div style="margin-left: 10px">类型：</div>
            <el-select v-model="mortar.type" :disabled="isLook" placeholder="请选择" style="width: 120px">
              <el-option key="1" label="倍数" :value="1"> </el-option>
              <el-option key="2" label="固定金额" :value="2"> </el-option>
            </el-select>
            <div style="margin-left: 10px">{{ mortar.type == 2 ? "固定金额:" : "倍数:" }}</div>
            <el-input v-model="mortar.multiple" :disabled="isLook" style="width: 140px" placeholder="请输入"> </el-input>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; margin-top: 10px">
            <div style="margin-right: 10px">上传附件:</div>
            <FileComponent2 style="width: 600px" fileCode="priceFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button v-if="!isLook" class="bottom_all" style="margin-left: 24px" @click="save()">确 定</el-button>
    </span>
    <!-- 添加组合类型 -->
    <el-dialog v-dialogDrag :visible.sync="addProductComposePriceDig" width="680px" :append-to-body="true" :close-on-click-modal="false" :before-close="closeProductComposePrice">
      <span slot="title" class="dialog-title">添加组合</span>
      <div class="dialoginfo">
        <el-form :model="ProductComposePriceForm" class="demo-form" label-width="180px;">
          <el-form-item label="强度等级：">
            <el-select ref="function" v-model="ProductComposePriceForm.strengthGrade" value-key="name" placeholder="请选择">
              <el-option v-for="item in config_options.strengthGrade" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性能等级：">
            <el-select ref="function" v-model="ProductComposePriceForm.function" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in config_options.performanceGrade" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材料要求：">
            <el-select ref="material" v-model="ProductComposePriceForm.material" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in config_options.meterialRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="特殊要求：">
            <el-select ref="special" v-model="ProductComposePriceForm.special" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in config_options.specialRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外加剂要求：">
            <el-select ref="admixture" v-model="ProductComposePriceForm.admixture" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in config_options.admixtureRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他要求：">
            <el-select ref="other" v-model="ProductComposePriceForm.other" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in config_options.otherRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeProductComposePrice()">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="addProductComposePrice()">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { queryDisclose, queryInfoReadjustCostDetail, saveOrUpdateInfoConsultPrice } from "@/api/internetSales/engineeringControl.js";
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import { updateStatus } from "@/api/internetSales/engineeringControl.js";

export default {
  components: {
    FileComponent2,
  },
  props: {
    negotiatePricesDialog: {
      type: Boolean,
      default: false,
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    data: {
      effectiveTime: "",
    },
    engineeringInfo: {
      type: Object,
      default: new Object(),
    },
  },
  watch: {
    negotiatePricesDialog(value) {
      if (value) {
        this.queryInfoReadjustCostDetailFun();
        this.queryDiscloseFun();
      }
    },
  },
  data() {
    return {
      fromDate: [],
      mainDate: {
        strengthGrade: [],
        performanceGrade: [],
        meterialRequirements: [],
        otherRequirements: [],
        admixtureRequirements: [],
        specialRequirements: [],
      },
      tableData_other: [],
      table_other: [
        { label: "特殊产品", width: "auto", prop: "productName", status: true },
        { label: "费用标准", width: "auto", prop: "costStandard", status: true },
        { label: "含税价格", width: "auto", prop: "priceIncludinTax", status: true },
        { label: "不含税价格", width: "auto", prop: "priceExcludingTax", status: true },
      ],
      table_other_options: [
        { value: 1, label: "按车收费" },
        { value: 0, label: "不收费" },
        { value: 2, label: "按方量收费" },
      ],
      config_options: {
        strengthGrade: [],
        performanceGrade: [],
        meterialRequirements: [],
        otherRequirements: [],
        admixtureRequirements: [],
        specialRequirements: [],
      },
      mortar: {
        multiple: 0,
        type: 1,
        strengthGradeId: "0001",
        strengthGrade: "相同强度",
      },
      files: [],
      addProductComposePriceDig: false,
      ProductComposePriceForm: {
        function: [],
        material: [],
        special: [],
        admixture: [],
        other: [],
        strengthGrade:{},
      },
      productComposePriceList: [], //组合类型
    };
  },
  methods: {
    priceExcludingTaxFun(val) {
      val.priceExcludingTax = ((val.priceIncludinTax * 1) / (1 + this.data.taxRate * 1)).toFixed(2);
    },
    priceIncludinTaxFun(val) {
      val.priceIncludinTax = ((val.priceExcludingTax * 1) * (1 + this.data.taxRate * 1)).toFixed(2);
    }, 
    selectMortarFun(val) {
      this.mortar.strengthGrade = val.name;
      this.mortar.strengthGradeId = val.id;
    },
    close() {
      this.productComposePriceList = [];
      this.$emit("closeNegotiatePricesDialog", false);
    },
    save() {
      let productTypesList = this.tableData_other.map(item => {
        return {
          costStandard: item.costStandard,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          productId: item.productId,
          productName: item.productName,
        };
      });
      let list = [
        ...(this.mainDate.strengthGrade || []),
        ...(this.mainDate.performanceGrade || []),
        ...(this.mainDate.meterialRequirements || []),
        ...(this.mainDate.specialRequirements || []),
        ...(this.mainDate.admixtureRequirements || []),
        ...(this.mainDate.otherRequirements || []),
      ];
      let type = false;
      this.productComposePriceList.forEach(item => {
        if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
          type = true;
        }
      });
      // productTypesList.forEach(item => {
      //     if(item.priceIncludinTax !== 0 && !item.priceIncludinTax){
      //         type = true
      //     }
      //     if(item.costStandard !== 0 && !item.costStandard){
      //         type = true
      //     }
      // })
      list.forEach(item => {
        if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
          type = true;
        }
      });
      if (type) {
        this.$message.warning("表格数据不允许为空!");
        return;
      }
      if (!this.mortar.type || !this.mortar.multiple) {
        this.$message.warning("同比例砂浆数据不允许为空!");
        return;
      }
      saveOrUpdateInfoConsultPrice({
        readjustPricesResordId: this.data.id,
        appendix: JSON.stringify(this.files),
        priceType: this.data.priceType,
        productComposePriceList: this.productComposePriceList,
        mortar: this.mortar,
        productAskList: list,
        productTypes: productTypesList,
      }).then(res => {
        if (res.code == 1001) {
          this.$message({ message: "保存成功", type: "success" });
          this.close();
          if (this.data.sureMaintain == 0) {
            updateStatus({
              id: this.data.id,
              sureMaintain: 1,
            }).then(() => {
              this.close();
            })
          } else {
            this.close();
            let obj = {
              id: this.data.engineeringId,
              name: this.engineeringInfo.name,
              readjustPricesResordId: this.data.id,
              priceType:this.data.priceType,
              effectiveTime:this.data.effectiveTime,
            }
            this.$router.push({ name: "priceMaintenance_sign", query: { dataContent: JSON.stringify(obj), type: 1 } });
          }
        }
      });
    },
    addProductComposePrice() {
      let askName = "";
      if (
        this.ProductComposePriceForm.function.length == 0 &&
        this.ProductComposePriceForm.material.length == 0 &&
        this.ProductComposePriceForm.special.length == 0 &&
        this.ProductComposePriceForm.other.length == 0 &&
        this.ProductComposePriceForm.admixture.length == 0 &&
        !this.ProductComposePriceForm.strengthGrade.name
      ) {
        this.$message.warning("请选择一项要求再添加！");
        return;
      }
      //顺序:强度等级、性能、材料、特殊、其他、外加剂
      askName = askName + this.ProductComposePriceForm.strengthGrade.name;
      this.ProductComposePriceForm.function.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.material.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.special.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.other.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.admixture.forEach(item => {
        askName = askName + item.name;
      });
      let item = {
        productName: askName,
        admixtureRequirements: JSON.stringify(this.ProductComposePriceForm.admixture),
        meterialRequirements: JSON.stringify(this.ProductComposePriceForm.material),
        otherRequirements: JSON.stringify(this.ProductComposePriceForm.other),
        performanceGrade: JSON.stringify(this.ProductComposePriceForm.function),
        priceExcludingTax: "",
        priceIncludinTax: "",
        specialRequirements: JSON.stringify(this.ProductComposePriceForm.special),
        strengthGrade: this.ProductComposePriceForm.strengthGrade.name,
        strengthGradeId: this.ProductComposePriceForm.strengthGrade.id
      };
      this.productComposePriceList.push(item);
      this.closeProductComposePrice();
    },
    closeProductComposePrice() {
      this.addProductComposePriceDig = false;
      this.ProductComposePriceForm = this.$options.data().ProductComposePriceForm;
    },
    deleteProductComposePrice(index) {
      this.productComposePriceList.splice(index, 1);
    },
    queryInfoReadjustCostDetailFun() {
      queryInfoReadjustCostDetail({ readjustPricesResordId: this.data.id, priceType: this.data.priceType }).then(res => {
        if (res.code == 1001 && res.data) {
          if (res.data.informationPriceGradeList) {
            res.data.informationPriceGradeList.forEach(item => {
              item["areaCode0"] = item.areaCode ? JSON.parse(item.areaCode) : [];
            });
            this.fromDate = res.data.informationPriceGradeList;
            console.log(this.fromDate);
          }
          if (res.data.productAskMap) {
            this.mainDate = res.data.productAskMap;
          }
          if (res.data.productTypes) {
            this.tableData_other = res.data.productTypes;
          }
          if (res.data.mortar) {
            this.mortar = res.data.mortar;
            this.mortar.strengthGradeId = "0001";
            this.mortar.strengthGrade = "相同强度";
          }
          if (res.data.productComposePriceList) {
            this.productComposePriceList = res.data.productComposePriceList;
          }
          if (res.data.appendix == "[]") {
            this.files = [];
          } else {
            this.files = JSON.parse(res.data.appendix) || [];
          }
        }
      });
    },
    queryDiscloseFun() {
      queryDisclose({ engId: this.data.engineeringId }).then(res => {
        if (res.code == 1001) {
          this.config_options.strengthGrade = res.data.strengthGrade || [];
          this.config_options.performanceGrade = res.data.performanceGrade || [];
          this.config_options.meterialRequirements = res.data.meterialRequirements || [];
          this.config_options.otherRequirements = res.data.otherRequirements || [];
          this.config_options.admixtureRequirements = res.data.admixtureRequirements || [];
          this.config_options.specialRequirements = res.data.specialRequirements || [];
        }
      });
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>